<template>
  <div class="dash-wrap">


    <div class="main-content">

      <!-- Stats -->
      <template v-if="loaded">
        <div class="section-label">Overview — Today</div>
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-icon red"><i class="fa fa-dollar"></i></div>
            <div class="stat-val" :class="info.stats.today_sales == '0.00' ? 'danger' : 'success'">
              {{ info.stats.today_sales }}
            </div>
            <div class="stat-label">Today Sales</div>
          </div>
          <div class="stat-card">
            <div class="stat-icon green"><i class="fa fa-credit-card"></i></div>
            <div class="stat-val" :class="info.stats.total_credit == '0.00' ? 'danger' : 'success'">
              {{ info.stats.total_credit }}
            </div>
            <div class="stat-label">Total Credit</div>
          </div>
          <div class="stat-card">
            <div class="stat-icon blue"><i class="fa fa-users"></i></div>
            <div class="stat-val">{{ info.stats.users }}</div>
            <div class="stat-label">Users</div>
          </div>
          <div class="stat-card">
            <div class="stat-icon amber"><i class="fa fa-bell"></i></div>
            <div class="stat-val">{{ info.stats.subscribers }}</div>
            <div class="stat-label">Subscribers</div>
          </div>
        </div>

        <div class="panel chart-panel" v-if="chartLoaded">
          <div class="chart-panel__header">
            <div class="panel-title">
              <i class="fa fa-bar-chart"></i> Daily Sales Statistics
            </div>
          </div>
          <apexchart
              type="bar"
              height="320"
              :options="chartOptions"
              :series="series"
          ></apexchart>
        </div>

        <div class="bottom-grid">
          <!-- Quick Access + Chart -->
          <div class="panel">
            <div class="panel-title"><i class="fa fa-th-large"></i> Quick Access</div>
            <div class="btn-grid">
              <div class="nav-btn" @click="$router.push('/orders')">
                <div class="nav-btn-icon"><i class="fa fa-list"></i></div>
                <span>Booked List</span>
              </div>
              <div class="nav-btn" @click="$router.push('/gifts')">
                <div class="nav-btn-icon"><i class="fa fa-gift"></i></div>
                <span>Gifts List</span>
              </div>
              <div class="nav-btn" @click="$router.push('/carts')">
                <div class="nav-btn-icon"><i class="fa fa-shopping-cart"></i></div>
                <span>Carts List</span>
              </div>
              <div class="nav-btn" @click="$router.push('/users')">
                <div class="nav-btn-icon"><i class="fa fa-user"></i></div>
                <span>Customers</span>
              </div>
            </div>
          </div>

          <!-- Quick Search -->
          <div class="panel">
            <div class="panel-title"><i class="fa fa-search"></i> Quick Search</div>
            <div class="search-panel">
              <div class="search-group">
                <label>Customer (email / name / phone)</label>
                <input v-model="userSearchInput" type="text" placeholder="Search customers..." />
                <button class="btn-primary" @click="searchUser">Search Customer</button>
              </div>
              <div class="search-row">
                <div class="search-field">
                  <label>Order ID</label>
                  <input ref="orderSearchInput" type="text" placeholder="e.g. 1042" />
                </div>
                <button class="btn-dark" @click="$router.push(`/orders/${$refs.orderSearchInput.value}`)">Go →</button>
              </div>
              <div class="search-row">
                <div class="search-field">
                  <label>Cart ID</label>
                  <input ref="cartSearchInput" type="text" placeholder="e.g. 88" />
                </div>
                <button class="btn-dark" @click="$router.push(`/carts/${$refs.cartSearchInput.value}`)">Go →</button>
              </div>
              <div class="search-row">
                <div class="search-field">
                  <label>Gift Ref Code</label>
                  <input ref="GiftRefCodeSearchInput" type="text" placeholder="e.g. GIFT-XY9" />
                </div>
                <button class="btn-dark" @click="searchGiftByRefCode($refs.GiftRefCodeSearchInput.value)">Go →</button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Skeleton loading -->
      <template v-if="!loaded">
        <div class="stats-grid">
          <div class="stat-card skeleton" v-for="i in 4" :key="i"></div>
        </div>
        <div class="bottom-grid">
          <div class="panel skeleton" style="height:320px;"></div>
          <div class="panel skeleton" style="height:320px;"></div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import { config } from "../helpers";

export default {
  name: "Home",
  data() {
    return {
      loaded: false,
      chartLoaded: false,
      info: [],
      userSearchInput: "",
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          background: 'transparent',
          zoom: { enabled: false },
        },
        theme: { mode: 'dark' },
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: '60%',
          }
        },
        colors: ['#f42f4b', '#22c55e'],
        grid: {
          borderColor: '#1e1e1e',
          strokeDashArray: 3,
          padding: { left: 10, right: 10 },
        },
        xaxis: {
          categories: [],
          labels: {
            style: { colors: '#555', fontSize: '11px' },
            rotate: -45,
            rotateAlways: false,
          },
          tickAmount: 20,
        },
        yaxis: {
          labels: { style: { colors: '#555' } },
        },
        tooltip: {
          theme: 'dark',
          y: { formatter: (val) => `${val} AED` },
        },
        title: { text: '' },
      }
    };
  },
  mounted() {
    this.loadInfo();
    this.getStatistic();
  },
  methods: {
    loadInfo() {
      axios.get(config("BACKEND_ROOT") + "/admin/dashboard-info").then(r => {
        this.info = r.data;
        this.loaded = true;
      });
    },
    getStatistic() {
      axios.get(config("BACKEND_ROOT") + "/admin/statistic/sell").then(r => {
        this.chartOptions.xaxis.categories = r.data.data.days;
        this.series = r.data.data.series;
        this.chartLoaded = true;
      });
    },
    searchUser() {
      this.$router.push({ name: "users", params: { q: this.userSearchInput } });
    },
    searchGiftByRefCode(refCode) {
      axios.get(config("BACKEND_ROOT") + `/admin/gifts?ref_code=${refCode}`).then(r => {
        const data = r.data.data;
        if (data.length == 1) this.$router.push(`/gifts/${data[0].id}`);
        else alert('Not found!');
      });
    },
  },
  watch: {
    '$root.isLight'() {
      this.chartLoaded = false;
      this.$nextTick(() => { this.chartLoaded = true; });
    }
  }
};
</script>

<style lang="scss" scoped>
/* ============================================
   Dashboard.vue — <style scoped>
   همه رنگ‌ها از CSS Variables میان (تم‌پذیر)
   ============================================ */

* { box-sizing: border-box; }
.chart-panel {
  margin-bottom: 12px;
  /* panel قبلاً داشت: background, border, border-radius, padding */
}

.chart-panel__header {
  margin-bottom: 0.5rem;
}

/* ── Layout ── */
.dash-wrap {
  background: var(--bg-base);
  min-height: 100vh;
  color: var(--text-1);
  font-family: 'Inter', sans-serif;
}

.main-content { padding: 1.5rem; }

.section-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-3);
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

/* ── Stat Cards ── */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 1.5rem;
}

.stat-card {
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.1rem 1.25rem;
  transition: border-color .2s;
}

.stat-card:hover { border-color: var(--border-2); }

.stat-icon {
  width: 32px; height: 32px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: .75rem;
  font-size: 15px;
}
.stat-icon.red   { background: rgba(244, 47, 75, 0.12); color: #f42f4b; }
.stat-icon.green { background: rgba(34, 197, 94, 0.10); color: #22c55e; }
.stat-icon.blue  { background: rgba(129,140,248, 0.12); color: #818cf8; }
.stat-icon.amber { background: rgba(245,158, 11, 0.10); color: #f59e0b; }

.stat-val {
  font-size: 20px;
  font-weight: 500;
  color: var(--text-1);
  margin-bottom: 3px;
}
.stat-val.danger  { color: #f42f4b; }
.stat-val.success { color: #22c55e; }

.stat-label { font-size: 12px; color: var(--text-3); }
.stat-change { font-size: 11px; color: var(--text-3); margin-top: 4px; }

/* ── Bottom Grid ── */
.bottom-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.panel {
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  transition: background .2s, border-color .2s;
}

.panel-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-2);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Quick Access Buttons ── */
.btn-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }

.nav-btn {
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background .15s, border-color .15s;
}
.nav-btn:hover { border-color: var(--accent); }

.nav-btn-icon {
  width: 30px; height: 30px;
  border-radius: 7px;
  background: rgba(244, 47, 75, 0.1);
  color: var(--accent);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
}

.nav-btn span {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-2);
}

/* ── Quick Search ── */
.search-panel { display: flex; flex-direction: column; gap: 10px; }
.search-group { display: flex; flex-direction: column; gap: 6px; }
.search-row   { display: flex; gap: 8px; align-items: flex-end; }
.search-field { flex: 1; }

.search-field label,
.search-group label {
  display: block;
  font-size: 11px;
  color: var(--text-3);
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: .4px;
}

.search-field input,
.search-group input {
  width: 100%;
  height: 36px;
  background: var(--bg-base);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text-1);
  font-size: 13px;
  padding: 0 10px;
  outline: none;
  transition: border-color .15s, background .15s;
}
.search-field input::placeholder,
.search-group input::placeholder { color: var(--text-3); }

.search-field input:focus,
.search-group input:focus {
  border-color: var(--accent);
  background: var(--bg-hover);
}

.btn-primary {
  height: 36px;
  width: 100%;
  background: var(--accent);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity .15s;
}
.btn-primary:hover { opacity: .88; }

.btn-secondary {
  height: 36px;
  padding: 0 14px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text-2);
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: border-color .15s, color .15s;
}
.btn-secondary:hover { border-color: var(--accent); color: var(--accent); }

/* ── Chart section ── */
.chart-divider {
  border-top: 1px solid var(--border);
  margin-top: 1.25rem;
  padding-top: 1.25rem;
}

/* ── Skeleton ── */
.skeleton {
  background: linear-gradient(
      90deg,
      var(--bg-panel) 25%,
      var(--bg-hover) 50%,
      var(--bg-panel) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;
}
@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .bottom-grid    { grid-template-columns: 1fr; }
  .stats-grid     { grid-template-columns: repeat(2, 1fr); }
  .main-content   { padding: 1rem; }
}
</style>